import { Group } from "../areas/types";
import { PasswordModel } from "../my-account/types";

export interface UserManagementState {
	userList: UserDetails[];
	permissions: Permission[];
	userRoles: UserRole[];
	userDomains: Domain[];
	domains: Domain[];
	domainGroups: DomainGroup[];
	userGroups: UserGroup[];
	contacts: ContactUser[];
	contactRoles: ContactRole[];
	pageIndex: number;
	pageSize: number;
	allUsersRetrieved: boolean;
	userTableIsBusy: boolean;
	includeBlankUsernames: boolean;
	domainModal: DomainModal;
}

export interface UserDetails {
	userID: number;
	username: string;
	fullName: string;
	email: string | null;
	address: string | null;
	telephone: string | null;
	mobile: string | null;
	groupID: number;
	isSiteStaff: boolean;
	mobileAppEnabled: boolean;
	groupName: string | null;
	disabled?: boolean;
	disabledAt: Date | null;
	lockedOutUntil: Date | null;
	lastLoginAt: Date | null;
	password: string;
	permissions: any[];
	permissionsGroup: any[] | null;
	userGroupMembershipTitles: string[] | null;
	readOnly?: boolean;
	timeZoneId: number;
	name?: string;
	passwordSalt?: string;
	contactRoles?: ContactRole[];
	contactRoleGroups?: UserGroup[];
	notes?: string;
	isSystemAdmin?: boolean;
	receiveIncidentEmails?: boolean;
	receiveUpdateEmails?: boolean;
	sitePassword?: string;
}

export interface Contact {
	userID: number;
	groupID: number;
	isSiteStaff: boolean;
	role: string;
	email: string;
	name: string;
	telephone: string;
	contactGroupIDs: any[] | null;
}

export interface ContactRole {
	contactRoleId: number;
	groupId: number;
	role: string;
}

export interface UserGroup {
	userGroupId: number;
	title: string;
	groupID: number;
	landingPage?: string;
	duressServerTypeID: number | null;
	duressEventNum: number | null;
	duressServerEventTypeTitle: string | null;
}

export interface UserGroupRole {
	userGroupID: number;
	groupID: number;
	userRoleID: number;
	inherit: number;
}

export interface Permission {
	permissionId: number;
	title: string;
	extendedValueTitle: string | null;
	extendedValueDataType: string | null;
	description: string;
	category: string;
}

export interface PermissionExtended extends Permission {
	hasPermission: boolean;
	extended: any;
	secondPermission: PermissionExtended;
}

export interface UserRolePermission {
	userRoleId: number;
	permissionId: number;
	permission: Permission;
	extended: string;
}

export interface UserRole {
	userRoleId: number;
	title: string;
	groupID: number;
	permissions: UserRolePermission[];
}

export interface Domain {
	domainId: number;
	domainName: string;
	groupId: number;
}

export interface DomainGroup {
	domainId: number;
	domainGroupName: string;
	userGroupId: number;
	userGroupTitle: string;
}

/**
 * Updated interface. Backend is returning different results to above.
 */
export interface ContactUser {
	address: string;
	contactRoleGroups: number[];
	contactRoles: ContactRole;
	email: string;
	groupID: number;
	isSiteStaff: boolean;
	name: string;
	permissions: any[];
	role: string;
	sitePassword: string;
	telephone: string;
	mobile?: string;
	userID: number;
	username: string;
	contactGroupIDs?: any[] | null;
	notes?: string;
	receiveIncidentEmails?: boolean;
	receiveUpdateEmails?: boolean;
}

export interface RecoveryQuestion {
	userQuestionId: number;
	title: string;
}

export interface ResetPasswordDetails {
	userName: string;
	answer1: string;
	answer2: string;
	answer3: string;
	newPassword: string;
}

export interface PasswordChangeResult {
	validationMessage: string | null;
	complexityChecks: { [key: string]: number } | null;
	successful: boolean;
}

export interface ResetPasswordResponse {
	status: RecoveryStatus;
	validationMessage: string | null;
	complexityChecks: { [key: string]: number } | null;
	successful: boolean;
}

export interface UserQuestionsUpdate {
	question1Id: number;
	answer1: string;
	question2Id: number;
	answer2: string;
	question3Id: number;
	answer3: string;
	confirmationPassword: string;
}

export enum RecoveryStatus {
	Success,
	Failed,
	UserNotFound,
	InvalidPassword,
	InsufficientAnswerQuantity,
	LockedOut,
	Error
}

export interface RenewPasswordDetails extends PasswordModel {
	Username : string;
}

export interface DomainModal {
	shown: boolean;
	domainId: number;
}
